import React from 'react';
import { bool } from 'prop-types';
import { translate } from '@fiverr-private/i18n-react';
import { FileIcon, ChatIcon } from '@fiverr-private/visuals';
import { Stack } from '@fiverr-private/layout_components';
import { PopoverContent as ContentOfPopover } from '@fiverr-private/popover';
import { Box } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';

import { useGigPageContext } from '@fiverr-private/gig_page_context';
import CustomOrder from '../../../shared/CustomOrder';
import ContactSellerBtn from '../../ContactSellerBtn';
import { ConsultationButton } from '../../ConsultationButton/ConsultationButton';
import { ContactSellerOption } from '../../ContactSellerOption/ContactSellerOption';
import { ResponsiveIcon } from '../../ResponsiveIcon/ResponsiveIcon';

const MP_SOURCE_COMPONENT = 'Gig page contact seller options button';
const BQ_SOURCE_NAME = 'ask_a_question';
const CUSTOM_ORDER_BQ_SOURCE_NAME = 'contact_seller';

const PopoverContent = ({ customOrderEligible }) => {
    const { seller } = useGigPageContext();

    const { isAgency } = seller;
    const headerTitle = isAgency ?
        `gig_page_perseus.contact_seller_options.popover.title_agency` :
        `gig_page_perseus.contact_seller_options.popover.title`;

    const triggerCopy = translate(`gig_page_perseus.contact_seller_options.popover.contact_seller`);

    return (
        <ContentOfPopover disablePadding closeOnClickOutside={false}>
            <Box
                width={{ default: 'calc(100vw - 48px)', sm: 'max-content' }}
                minWidth={{ default: "240px", sm: "345px"}}
                maxWidth="500px"
                padding={{ default: '1', sm: '5' }}
                boxSizing="borderBox"
            >
                <Text
                    size={{ default: 'b_sm', sm: 'b_md' }}
                    fontWeight="bold"
                    marginBottom="2"
                    textAlign="start"
                    paddingX={{ default: '3', sm: '0' }}
                    paddingTop={{ default: '3', sm: '0' }}
                >
                    {translate(headerTitle)}
                </Text>
                <Stack gap={{default: "1", sm:"2"}} direction="column">
                    {customOrderEligible && (
                        <CustomOrder
                            bqSourceName={CUSTOM_ORDER_BQ_SOURCE_NAME}
                            triggerId="Contact Seller"
                            triggerCopy={translate('gig_page_perseus.contact_seller_options.popover.get_a_quote')}
                            triggerPlacement="Contact me dropdown"
                        >
                            <ContactSellerOption
                                title={translate('gig_page_perseus.contact_seller_options.popover.get_a_quote')}
                                IconComponent={<ResponsiveIcon Icon={FileIcon}/>}
                            />
                        </CustomOrder>
                    )}
                    <ContactSellerBtn
                        asContactSellerOption
                        mixpanelSourceComponent={MP_SOURCE_COMPONENT}
                        bqSourceName={BQ_SOURCE_NAME}
                        triggerId={"Contact Seller"}
                        triggerCopy={triggerCopy}
                        triggerPlacement="Contact me dropdown"
                    >
                        <ContactSellerOption
                            title={triggerCopy}
                            IconComponent={<ResponsiveIcon Icon={ChatIcon}/>}
                        />
                    </ContactSellerBtn>
                    <ConsultationButton/>
                </Stack>
            </Box>
        </ContentOfPopover>
    );
};

PopoverContent.propTypes = {
    customOrderEligible: bool,
};

export default PopoverContent;
